export class ThcAccordionBanner extends HTMLElement {
  #isOpened = false;

  connectedCallback() {
    this.#init();
  }

  #init() {
    // Set initial collapsed state for smooth transitions
    const body = this.content;
    if (body) {
      body.style.maxHeight = '0';
      body.style.overflow = 'hidden';
    }
    this.toggleBtn.addEventListener('click', this.#toggle.bind(this));
  }

  #toggle() {
    this.#isOpened ? this.close() : this.open();
  }

  open() {
    if (this.#isOpened) return;
    const body = this.content;
    if (body) body.style.maxHeight = body.scrollHeight + 'px';
    this.toggleBtn.classList.add('open');
    this.#isOpened = true;
  }

  close() {
    if (!this.#isOpened) return;
    const body = this.content;
    if (body) body.style.maxHeight = '0';
    this.toggleBtn.classList.remove('open');
    this.#isOpened = false;
  }

  get toggleBtn() {
    return this.querySelector('.toggle-accordion');
  }

  get content() {
    return this.querySelector('.accordion-body');
  }
}

if (!customElements.get('thc-accordion-banner')) {
  customElements.define('thc-accordion-banner', ThcAccordionBanner);
}